export default __webpack_public_path__ + "static/media/govbr.16bc87af.svg";